import { Incasso } from '../../../models/incasso';

export class IncassoAdapter {
  incasso: Incasso = new Incasso();
  constructor(incasso: Incasso) {
    this.incasso.id = incasso.id ;
    this.incasso.dataIncasso = incasso.dataIncasso ;
    this.incasso.causale = incasso.causale ;
    this.incasso.soggettoPagatore = incasso.soggettoPagatore  ?  JSON.parse(JSON.stringify(incasso.soggettoPagatore)) : null;
    this.incasso.areaCompetente = incasso.areaCompetente  ?  JSON.parse(JSON.stringify(incasso.areaCompetente)) : null;
    this.incasso.importo = incasso.importo ;
    this.incasso.interessi = incasso.interessi ;
    this.incasso.spese = incasso.spese ;
    this.incasso.importoPattuito = incasso.importoPattuito ? incasso.importoPattuito : null;
    this.incasso.importo = incasso.importo ? incasso.importo : null;
    this.incasso.compensoAvvocati = incasso.compensoAvvocati ;
    this.incasso.tipoIncasso = incasso.tipoIncasso  ?  JSON.parse(JSON.stringify(incasso.tipoIncasso)) : null;
    this.incasso.modalitaIncasso = incasso.modalitaIncasso  ?  JSON.parse(JSON.stringify(incasso.modalitaIncasso)) : null;
    this.incasso.note = incasso.note ;
    this.incasso.documenti = incasso.documenti  ?  JSON.parse(JSON.stringify(incasso.documenti)) : null;
    this.incasso.incassiSoggetti = incasso.incassiSoggetti  ?  JSON.parse(JSON.stringify(incasso.incassiSoggetti)) : null;
  };

}
